import { cn } from "@/lib/cn";

export interface DividerProps extends React.HTMLAttributes<HTMLDivElement> {
  orientation?: "horizontal" | "vertical";
  label?: React.ReactNode;
}

/** Reemplazo de `<Divider>` de Mantine · línea `border-border`, opcionalmente con label centrado. */
export function Divider({ orientation = "horizontal", label, className, ...props }: DividerProps) {
  if (orientation === "vertical") {
    return <div className={cn("w-px self-stretch bg-border", className)} {...props} />;
  }
  if (label) {
    return (
      <div className={cn("flex items-center gap-3", className)} {...props}>
        <span className="h-px flex-1 bg-border" />
        <span className="text-xs text-muted-foreground">{label}</span>
        <span className="h-px flex-1 bg-border" />
      </div>
    );
  }
  return <div className={cn("h-px w-full bg-border", className)} {...props} />;
}
